export default {
  hint: 'Bevestig de betaling bij je bank om je bestelling af te ronden.',
  cancel: 'Betaling annuleren',
};
